import { web3Accounts, web3Enable } from "@polkadot/extension-dapp";
import React, { useContext, useEffect, createContext, useState } from "react";
import { useActiveWeb3React } from "../hooks";
const context = createContext();



export const PolkaContextProvider = ({ children }) => {
    const [account, setAccount] = useState();
    const [signer, setSigner] = useState();
    const { library } = useActiveWeb3React();

    useEffect(() => {
        updateLib();
    }, [library]);
    async function updateLib() {
        if (library?.api) {
            const injectedPromise = await web3Enable("reef.kwikswap");
            if (injectedPromise[0]?.signer) {
                setSigner(injectedPromise[0].signer)
            }
            const accounts = await web3Accounts();
            const storageselectedaccount = localStorage.getItem("selectedaccount");
            const selectedaccount = accounts.find(acc => acc.address === storageselectedaccount);
            if (selectedaccount || accounts[0].address) {
                setAccount(selectedaccount ? selectedaccount.address : accounts[0].address)
            }
        }
    }

    return (

        <context.Provider value={{ account, signer }}>
            {children}
        </context.Provider >
    )
}

export const usePolkaContext = () => {
    return useContext(context)
}